import api from '@/utils/api'

export default {
  data() {
    return {
      userName: '',
      userEmail: '',
      tokenUsage: {
        percentage: 0
      }
    }
  },
  methods: {
    async fetchUserInfo() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (userInfo) {
          this.userName = userInfo.name || ''
          this.userEmail = userInfo.email || ''
        } else {
          this.$router.push('/login')
          return false
        }
        return true
      } catch (error) {
        console.error('사용자 정보 조회 중 오류 발생:', error)
        return false
      }
    },
    async fetchTokenUsage() {
      try {
        const response = await api.getTokenUsage()
        this.tokenUsage = {
          percentage: Math.round((response.data.used / response.data.total) * 100)
        }
      } catch (error) {
        console.error('토큰 사용량 조회 중 오류 발생:', error)
      }
    }
  }
} 